module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    key: _vm.$route.fullPath
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "is-mobile"
  }, [_c('router-link', {
    staticClass: "button is-success",
    attrs: {
      "to": "/season-totals/team-select"
    }
  }, [_vm._v("Back to Teams")])], 1), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "title is-child is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "player_icon",
    staticStyle: {
      "margin": "0 auto",
      "display": "block"
    },
    attrs: {
      "src": _vm.Faceoffs.team.logo
    }
  }), _c('h1', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.Faceoffs.team.name) + " Stats")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Faceoffs")]), _vm._v(" "), _c('button', {
    staticClass: "button is-default",
    staticStyle: {
      "margin": "0 80%"
    },
    on: {
      "click": function($event) {
        return _vm.toggleFaceoffs()
      }
    }
  }, [_vm._v("Show / Hide")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFaceoffOpen),
      expression: "isFaceoffOpen"
    }],
    staticClass: "faceoffs"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.fo_total_chart,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(this.Faceoffs.total_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.total_wins))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.total_losses))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.total_win_percent))])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.fo_total_lane_chart,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Left")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.taken_left))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_left))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_left_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.losses_left))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Center")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.taken_center))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_center))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_center_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.losses_center))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Right")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.taken_right))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_right))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.wins_right_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Faceoffs.losses_right))])])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.fo_player_series,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((this.Faceoffs.players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fow_percent))])])
  }), 0)])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.fo_player_lane,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((this.Faceoffs.players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_left_wins) + " of " + _vm._s(player.player_lane_left_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_left_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_center_wins) + " of " + _vm._s(player.player_lane_center_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_center_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_right_wins) + " of " + _vm._s(player.player_lane_right_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_lane_right_percent))])])
  }), 0)])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.fo_player_zone,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((this.Faceoffs.players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_fot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_offensive_wins) + " of " + _vm._s(player.player_zone_offensive_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_offensive_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_neutral_wins) + " of " + _vm._s(player.player_zone_neutral_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_neutral_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_offensive_wins) + " of " + _vm._s(player.player_zone_defensive_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_zone_defensive_percent))])])
  }), 0)])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.fo_player_situation,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(12), _vm._v(" "), _c('tbody', _vm._l((this.Faceoffs.players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_fot))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_eh_wins) + " of " + _vm._s(player.player_situation_eh_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_eh_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_pp_wins) + " of " + _vm._s(player.player_situation_pp_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_pp_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_sh_wins) + " of " + _vm._s(player.player_situation_sh_taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_situation_sh_percent))])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(13), _vm._v(" "), _c('button', {
    staticClass: "button is-default",
    staticStyle: {
      "margin": "0 80%"
    },
    on: {
      "click": function($event) {
        return _vm.toggleFaceoffsPvp()
      }
    }
  }, [_vm._v("Show / Hide")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFaceoffsPvp),
      expression: "isFaceoffsPvp"
    }]
  }, _vm._l((this.Faceoffs.players), function(player) {
    return _c('div', [_c('div', {
      staticClass: "column",
      staticStyle: {
        "margin": "0 auto"
      }
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(player.player_id))])]), _vm._v(" "), _c('div', {
      staticClass: "block content"
    }, [_c('table', {
      staticClass: "table is-responsive"
    }, [_vm._m(14, true), _vm._v(" "), _c('tbody', _vm._l((player.player_vs_player), function(away_player) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(away_player.away_player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.taken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.wins))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.win_percent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.leftWins) + " of " + _vm._s(away_player.leftTaken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.centerWins) + " of " + _vm._s(away_player.centerTaken))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(away_player.rightWins) + " of " + _vm._s(away_player.rightTaken))])])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.so_total_chart,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(17), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Cardiff Devils")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.home_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.home_total_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.home_total_missed_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.home_total_blocked))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.average_total_home))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(this.Faceoffs.team.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.away_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.away_total_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.away_total_missed_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.away_total_blocked))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Shots.average_total_away))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "away-shots"
    }
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "child is-box box"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateHeatmaps()
      }]
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.text) + "\n                            ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodSelect),
      expression: "periodSelect"
    }],
    staticClass: "select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateHeatmaps()
      }]
    }
  }, _vm._l((_vm.periodOptions), function(pOption) {
    return _c('option', {
      domProps: {
        "value": pOption.value
      }
    }, [_vm._v("\n                          " + _vm._s(pOption.text) + "\n                          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "block styles-box"
  }, [_vm._m(20), _vm._v(" "), _c('p', [_c('slider', {
    staticClass: "slider is-primary",
    attrs: {
      "type": "primary",
      "value": 10,
      "max": 24,
      "min": 5,
      "step": 2
    },
    on: {
      "change": _vm.updateHeatmapSize
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-6"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Cardiff Devils - All shots")]), _vm._v(" "), _c('canvas', {
    ref: "home_shots_canvas",
    staticClass: "is-canvas-responsive",
    staticStyle: {
      "background": "url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"
    },
    attrs: {
      "width": "600",
      "height": "530"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(this.Faceoffs.team.name) + " - All shots")]), _vm._v(" "), _c('canvas', {
    ref: "away_shots_canvas",
    staticClass: "is-canvas-responsive",
    staticStyle: {
      "background": "url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"
    },
    attrs: {
      "width": "600",
      "height": "530"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-6"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Cardiff Devils - Power Play")]), _vm._v(" "), _c('canvas', {
    ref: "home_shots_canvas_pp",
    staticClass: "is-canvas-responsive",
    staticStyle: {
      "background": "url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"
    },
    attrs: {
      "width": "600",
      "height": "530"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(this.Faceoffs.team.name) + " - Power Play")]), _vm._v(" "), _c('canvas', {
    ref: "away_shots_canvas_pp",
    staticClass: "is-canvas-responsive",
    staticStyle: {
      "background": "url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"
    },
    attrs: {
      "width": "600",
      "height": "530"
    }
  })])])])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.shot_player_totals,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(22), _vm._v(" "), _c('tbody', _vm._l((this.Shots.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_missed_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_blocked))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_avg_game))])])
  }), 0)])]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.shot_away_player_totals,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(24), _vm._v(" "), _c('tbody', _vm._l((this.Shots.away_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_missed_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_blocked))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_avg_game))])])
  }), 0)])]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.shot_player_situational,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(26), _vm._v(" "), _c('tbody', _vm._l((this.Shots.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_on_net))])])
  }), 0)])]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.shot_away_player_situational,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(28), _vm._v(" "), _c('tbody', _vm._l((this.Shots.away_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_on_net))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_on_net))])])
  }), 0)])])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.to_totals,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(31), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(this.Turnovers.home_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Turnovers.home_total_offensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Turnovers.home_total_neutral))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Turnovers.home_total_defensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Turnovers.average_total_home))])])])])]), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_totals,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(33), _vm._v(" "), _c('tbody', _vm._l((this.Turnovers.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_offensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_neutral))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_defensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_avg_game))])])
  }), 0)])]), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.to_player_situational,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content",
    attrs: {
      "id": "pp"
    }
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(35), _vm._v(" "), _c('tbody', _vm._l((this.Turnovers.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_offensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_neutral))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_pp_defensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_offensive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_neutral))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_sh_defensive))])])
  }), 0)])])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    staticStyle: {
      "max-width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": 'doughnut',
      "data": _vm.hit_totals,
      "options": _vm.fo_total_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(38), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(this.Hits.home_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.Hits.average_total_home))])])])])]), _vm._v(" "), _vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-6 is-vertical",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('article', {
    staticClass: "tile is-child",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('chart', {
    attrs: {
      "type": 'bar',
      "data": _vm.hit_player_totals,
      "options": _vm.bar_options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block content"
  }, [_c('table', {
    staticClass: "table is-responsive"
  }, [_vm._m(40), _vm._v(" "), _c('tbody', _vm._l((this.Hits.home_players), function(player) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(player.player_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.player_avg_game))])])
  }), 0)])])]), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "is-child is-vertical",
    staticStyle: {
      "margin": "25px auto"
    }
  }, [_c('p', [_c('b', [_vm._v("Latest Updates:"), _c('br'), _vm._v("Load time increase due to render of heatmaps!?"), _c('br'), _vm._v("Added Faceoff PvP"), _c('br'), _vm._v("Added Graphs for each segment"), _c('br'), _vm._v("Added basic map controls - Shot type, Period, Shot Size")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Teams Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Wins - Losses")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("FOW")]), _vm._v(" "), _c('th', [_vm._v("FOL")]), _vm._v(" "), _c('th', [_vm._v("FOW%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Team By Lane "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Left - Center - Right")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("FOW")]), _vm._v(" "), _c('th', [_vm._v("FOW%")]), _vm._v(" "), _c('th', [_vm._v("FOL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Player Totals")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Taken - Wins - Losses - Win %")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("FOW")]), _vm._v(" "), _c('th', [_vm._v("FOL")]), _vm._v(" "), _c('th', [_vm._v("FOW%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Player By Lane "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Left - Center - Right")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("Left")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Center")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Right")]), _vm._v(" "), _c('th', [_vm._v("%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Player By Zone"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Offensive - Neutral - Defensive")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("Offensive")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Neutral")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Defensive")]), _vm._v(" "), _c('th', [_vm._v("%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Player By Situation"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Even Handed - Power Play - Short Handed")]), _c('p')])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("Even Handed")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Power Play")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Short Handed")]), _vm._v(" "), _c('th', [_vm._v("%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("Player Vs Player"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Wins/Losses Lanes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Vs Player")]), _vm._v(" "), _c('th', [_vm._v("FOT")]), _vm._v(" "), _c('th', [_vm._v("Wins")]), _vm._v(" "), _c('th', [_vm._v("%")]), _vm._v(" "), _c('th', [_vm._v("Left")]), _vm._v(" "), _c('th', [_vm._v("Center")]), _vm._v(" "), _c('th', [_vm._v("Right")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Shots")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Teams Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("On Net - Missed Net - Blocked - Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Team")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("On Net")]), _vm._v(" "), _c('th', [_vm._v("Missed Net")]), _vm._v(" "), _c('th', [_vm._v("Blocked")]), _vm._v(" "), _c('th', [_vm._v("Avg total shots per game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                        Shotmaps "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("All shots, all situations / All shots Powerplay (our Pk)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "bold-el"
  }, [_vm._v("Map Controls")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Heatmap size:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("On Net - Missed Net - Blocked - Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("On Net")]), _vm._v(" "), _c('th', [_vm._v("Missed Net")]), _vm._v(" "), _c('th', [_vm._v("Blocked")]), _vm._v(" "), _c('th', [_vm._v("Avg / Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Against Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("On Net - Missed Net - Blocked - Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("On Net")]), _vm._v(" "), _c('th', [_vm._v("Missed Net")]), _vm._v(" "), _c('th', [_vm._v("Blocked")]), _vm._v(" "), _c('th', [_vm._v("Avg / Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Home Situational  "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Power Play On Net - Short Handed On Net")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Power Play On Net")]), _vm._v(" "), _c('th', [_vm._v("Short Handed On Net")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Away Situational "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Power Play On Net - Short Handed On Net")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Power Play On Net")]), _vm._v(" "), _c('th', [_vm._v("Short Handed On Net")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Turnovers")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Team totals"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Offensive - Neutral - Defensive - Average / Game")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Offensive")]), _vm._v(" "), _c('th', [_vm._v("Neutral")]), _vm._v(" "), _c('th', [_vm._v("Defensive")]), _vm._v(" "), _c('th', [_vm._v("Avg total turnovers per game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Offensive - Neutral - Defensive - Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Offensive")]), _vm._v(" "), _c('th', [_vm._v("Neutral")]), _vm._v(" "), _c('th', [_vm._v("Defensive")]), _vm._v(" "), _c('th', [_vm._v("Avg / Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Situational Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(" PP / SH Total - Offensive - Neutral - Defensive ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("PP Total")]), _vm._v(" "), _c('th', [_vm._v("PP Offensive")]), _vm._v(" "), _c('th', [_vm._v("PP Neutral")]), _vm._v(" "), _c('th', [_vm._v("PP Defensive")]), _vm._v(" "), _c('th', [_vm._v("SH Total")]), _vm._v(" "), _c('th', [_vm._v("SH Offensive")]), _vm._v(" "), _c('th', [_vm._v("SH Neutral")]), _vm._v(" "), _c('th', [_vm._v("SH Defensive")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Hits")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                     Team totals"), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Hit Count - Average / Game")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Avg hits per game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                      Player Totals "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Hit Count -Avgerage / Games Played")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Player")]), _vm._v(" "), _c('th', [_vm._v("Hit Count")]), _vm._v(" "), _c('th', [_vm._v("Avg / Game")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "tile is-child box"
  }, [_c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Penalty Minutes (PIMS)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "tile is-child box"
  }, [_c('section', {
    staticClass: "hero is-dark bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Goals")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0415b576"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/season-totals/team-stats.vue
// module id = 574
// module chunks = 30